<script>
const version = 'v1.0';
const author = 'thor';
const contact = '896993802@qq.com';
const serveURL = './json/';
export default {
    version,
    author,
    contact,
    serveURL
}
</script>